import { render } from "./SearchResultsPage.vue?vue&type=template&id=1e0d9bf4&scoped=true"
import script from "./SearchResultsPage.vue?vue&type=script&lang=js"
export * from "./SearchResultsPage.vue?vue&type=script&lang=js"

import "./SearchResultsPage.vue?vue&type=style&index=0&id=1e0d9bf4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e0d9bf4"]])

export default __exports__